import styles from "./mobile.module.less";
import { Flex } from "antd";
import P4Card from "../components/P4Card";
import data from "../data";
import P1Content from "@/components/P1Content";
import banner from "./imgs/p1_bg.png";
import branchImg from "./imgs/p2_img1.png";
import p5Img from "./imgs/p5_img.png";
import p6Img from "./imgs/p6_img.png";


const MobileAboutUs = () => {
  const { p1, p2, p3, p4 } = data;
  return (
    <div className={styles.aboutPage}>
      <P1Content
        title={p1.title}
        subtitle={p1.subtitle}
        showBtn={false}
        style={{
          backgroundImage: `url(${banner})`,
        }}
      />
      <div className={styles.p2}>
        <div className={styles.p2_inner}>
          <div className={styles.pageTitle}>{p2.title}
          <div className={styles.pageSubTitle}>{p2.subTitle}</div></div>
          <Flex
            vertical
            align="center"
            gap={".35rem"}
            className={styles.p2_intro}
          >
            <img className={styles.p2_img1} src={branchImg} />
            <Flex vertical gap={".2rem"}>
              <Flex gap={".23rem"} align="start">
                <img className={styles.p2_img2} src={p2.quoteImg} />
                {p2.description1}
              </Flex>
              <div>{p2.description2}</div>
            </Flex>
          </Flex>
        </div>
      </div>
      <div className={styles.p3}>
        <div className={styles.p3_inner}>
          <div className={styles.pageTitle}>{p3.title}
          <div className={styles.pageSubTitle}>{p3.subTitle}</div></div>
          <div className={styles.p3_list}>
            <Flex gap={'.09rem'}>
              {p3.list.map((row, rowIndex) => (
                <Flex
                  vertical
                  gap={'.09rem'}
                  key={rowIndex}
                  className={
                    rowIndex % 2 === 0 ? styles.p4_row_even : styles.p4_row_odd
                  }
                  style={{ flex: 1 }}
                >
                  {row.map((item, itemIndex) => (
                    <P4Card key={itemIndex} {...item} />
                  ))}
                </Flex>
              ))}
            </Flex>
          </div>
        </div>
      </div>

      <div className={styles.p4}>
        <div className={styles.p4_inner}>
          <div className={styles.pageTitle}>{p4.title}
          <div className={styles.pageSubTitle}>{p4.subTitle}</div></div>
          <img src={p5Img} />
          <img src={p6Img} />
        </div>
      </div>
    </div>
  );
};

export default MobileAboutUs;
